// extracted by mini-css-extract-plugin
export default {"link":"RedeemReport_link__DtPZT","no_hover":"RedeemReport_no_hover__Bh2Ig"};